import { AlertCircle, Check, CheckCheck, Clock } from 'lucide-react';

const STATUS_CONFIG: Record<string, { icon: typeof Check; className: string; label: string }> = {
  PENDING: { icon: Clock, className: 'text-muted-foreground', label: 'Pending' },
  SENT: { icon: Check, className: 'text-muted-foreground', label: 'Sent' },
  DELIVERED: { icon: CheckCheck, className: 'text-muted-foreground', label: 'Delivered' },
  READ: { icon: CheckCheck, className: 'text-blue-500', label: 'Read' },
  FAILED: { icon: AlertCircle, className: 'text-red-500', label: 'Failed' },
};

export const MessageStatusIcon = ({ status }: { status: string }) => {
  const config = STATUS_CONFIG[status] ?? STATUS_CONFIG.PENDING;
  const Icon = config.icon;
  return (
    <span title={config.label}>
      <Icon className={`h-3.5 w-3.5 ${config.className}`} />
    </span>
  );
};
